import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SESSION_QUERY_KEY } from './useSession';
import { filterStorage } from '../../components/analytics/filters/utils/filterStorage';
import { clearCsrfToken } from '../../utils/csrf';
import { apiFetch } from '../../utils/api-client';

export function useLogout({ onSuccess }: { onSuccess: () => void }) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const response = await apiFetch('/api/auth/logout', { method: 'POST' });
      queryClient.setQueryData([SESSION_QUERY_KEY], null);
      return response;
    },
    onSuccess: async () => {
      try {
        filterStorage.clear();
      } catch {
        // Ignore filterStorage errors during logout
      }

      clearCsrfToken();

      // Small delay to allow any pending operations to complete before navigation
      await new Promise(resolve => setTimeout(resolve, 100));

      queryClient.clear();
      onSuccess();
    },
  });
}
